import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KioskTextSection extends Component {
    render() {
        return(
            <div className="kiosk-confirmation">
                <div className="card flush-top">
                    <span className="kiosk-confirmation__text kiosk-text-theme">{this.props.text}</span>
                </div>
            </div>
        )
    }

}

KioskTextSection.propTypes = {
    text: PropTypes.string.isRequired,
}

KioskTextSection.defaultProps = {
}

export default KioskTextSection;
